{
  "_meta": {
    "name": "Atlas OMS Status Taxonomy",
    "version": "1.0.0",
    "note": "Single source of truth for every state surfaced in OMS. Backend enum values MUST match `code` field. Add new states here FIRST, then propagate to PRD §5 enum tables.",
    "source": "Atlas_OMS_Frontend_Print_Package_v0.1.pdf §05",
    "usage": "Import in components: statusIntent(order.status) returns 'success'|'warning'|'danger'|'info'|'neutral'"
  },
  "order": [
    {
      "code": "unpaid",
      "label_en": "Unpaid",
      "label_th": "ยังไม่ชำระ",
      "intent": "neutral"
    },
    {
      "code": "pending",
      "label_en": "Pending",
      "label_th": "รอดำเนินการ",
      "intent": "warning"
    },
    {
      "code": "packed",
      "label_en": "Packed",
      "label_th": "แพ็คแล้ว",
      "intent": "info"
    },
    {
      "code": "awaiting_shipment",
      "label_en": "Awaiting shipment",
      "label_th": "รอจัดส่ง",
      "intent": "info"
    },
    {
      "code": "ready_to_ship",
      "label_en": "Ready to ship",
      "label_th": "พร้อมส่ง",
      "intent": "info"
    },
    {
      "code": "shipped",
      "label_en": "Shipped",
      "label_th": "จัดส่งแล้ว",
      "intent": "success"
    },
    {
      "code": "delivered",
      "label_en": "Delivered",
      "label_th": "ส่งถึงปลายทาง",
      "intent": "success"
    },
    {
      "code": "cancelled",
      "label_en": "Cancelled",
      "label_th": "ยกเลิก",
      "intent": "danger"
    },
    {
      "code": "returned",
      "label_en": "Returned",
      "label_th": "คืนสินค้า",
      "intent": "warning"
    },
    {
      "code": "lost_by_3pl",
      "label_en": "Lost by 3PL",
      "label_th": "สูญหายโดย 3PL",
      "intent": "danger"
    },
    {
      "code": "damaged_by_3pl",
      "label_en": "Damaged by 3PL",
      "label_th": "เสียหายโดย 3PL",
      "intent": "danger"
    },
    {
      "code": "confirmed",
      "label_en": "Confirmed",
      "label_th": "ยืนยันแล้ว",
      "intent": "success",
      "_note": "Fixes typo 'Comfirmed' from old app."
    },
    {
      "code": "completed",
      "label_en": "Completed",
      "label_th": "เสร็จสิ้น",
      "intent": "success"
    },
    {
      "code": "received",
      "label_en": "Received",
      "label_th": "รับเข้า",
      "intent": "info"
    },
    {
      "code": "reserved",
      "label_en": "Reserved",
      "label_th": "จองแล้ว",
      "intent": "warning"
    },
    {
      "code": "picked",
      "label_en": "Confirm pick",
      "label_th": "ยืนยันหยิบ",
      "intent": "info"
    },
    {
      "code": "superseded",
      "label_en": "Superseded",
      "label_th": "ถูกแทนที่",
      "intent": "neutral"
    }
  ],
  "payment": [
    {
      "code": "payment_pending",
      "label_en": "Pending",
      "label_th": "รอชำระ",
      "intent": "warning"
    },
    {
      "code": "payment_success",
      "label_en": "Paid",
      "label_th": "ชำระแล้ว",
      "intent": "success"
    },
    {
      "code": "payment_failed",
      "label_en": "Failed",
      "label_th": "ชำระไม่สำเร็จ",
      "intent": "danger"
    }
  ],
  "promotion": [
    {
      "code": "draft",
      "label_en": "Draft",
      "label_th": "ฉบับร่าง",
      "intent": "neutral"
    },
    {
      "code": "active",
      "label_en": "Active",
      "label_th": "กำลังใช้งาน",
      "intent": "success"
    },
    {
      "code": "finished",
      "label_en": "Finished",
      "label_th": "สิ้นสุดแล้ว",
      "intent": "info"
    }
  ],
  "stock": [
    {
      "code": "healthy",
      "label_en": "Healthy",
      "label_th": "ปกติ",
      "intent": "success"
    },
    {
      "code": "low_stock",
      "label_en": "Low stock",
      "label_th": "ใกล้หมด",
      "intent": "warning"
    },
    {
      "code": "out_of_stock",
      "label_en": "Out of stock",
      "label_th": "หมดสต๊อก",
      "intent": "danger"
    },
    {
      "code": "oversold",
      "label_en": "Oversold",
      "label_th": "ขายเกินสต๊อก",
      "intent": "danger",
      "_note": "Sellable < 0. Display in red, never clamp to 0 in UI."
    }
  ],
  "sync": [
    {
      "code": "sync_in_progress",
      "label_en": "Syncing",
      "label_th": "กำลังซิงค์",
      "intent": "info"
    },
    {
      "code": "sync_ok",
      "label_en": "Synced",
      "label_th": "ซิงค์แล้ว",
      "intent": "success"
    },
    {
      "code": "sync_failed",
      "label_en": "Sync failed",
      "label_th": "ซิงค์ล้มเหลว",
      "intent": "danger"
    }
  ],
  "audit": [
    {
      "code": "success",
      "label_en": "Success",
      "label_th": "สำเร็จ",
      "intent": "success",
      "_note": "GlobalAuditResult — global audit log Result column/filter."
    },
    {
      "code": "partial",
      "label_en": "Partial",
      "label_th": "สำเร็จบางส่วน",
      "intent": "warning"
    },
    {
      "code": "failed",
      "label_en": "Failed",
      "label_th": "ล้มเหลว",
      "intent": "danger"
    }
  ],
  "review_reason": [
    {
      "code": "oversold",
      "label_en": "Oversold",
      "label_th": "ขายเกินสต๊อก",
      "intent": "danger"
    },
    {
      "code": "buyer_cancel_requested",
      "label_en": "Buyer cancel request",
      "label_th": "ผู้ซื้อขอยกเลิก",
      "intent": "warning"
    },
    {
      "code": "sku_unmapped",
      "label_en": "SKU unmapped",
      "label_th": "SKU ยังไม่ผูกข้อมูล",
      "intent": "neutral"
    },
    {
      "code": "money_parse_failed",
      "label_en": "Money parse failed",
      "label_th": "แปลงยอดเงินไม่สำเร็จ",
      "intent": "neutral"
    },
    {
      "code": "non_thb_currency",
      "label_en": "Non-THB currency",
      "label_th": "สกุลเงินไม่ใช่บาท",
      "intent": "neutral"
    }
  ],
  "push_mode": [
    {
      "code": "off",
      "label_en": "Off",
      "label_th": "ปิด",
      "intent": "neutral"
    },
    {
      "code": "shadow",
      "label_en": "Shadow",
      "label_th": "โหมดเงา",
      "intent": "info"
    },
    {
      "code": "live",
      "label_en": "Live",
      "label_th": "ใช้งานจริง",
      "intent": "success"
    }
  ],
  "push_result": [
    {
      "code": "ok",
      "label_en": "OK",
      "label_th": "สำเร็จ",
      "intent": "success"
    },
    {
      "code": "shadow",
      "label_en": "Shadow",
      "label_th": "โหมดเงา",
      "intent": "info"
    },
    {
      "code": "failed",
      "label_en": "Failed",
      "label_th": "ล้มเหลว",
      "intent": "danger"
    },
    {
      "code": "no_listing",
      "label_en": "No listing",
      "label_th": "ไม่มีประกาศขาย",
      "intent": "neutral"
    },
    {
      "code": "held_multi_warehouse",
      "label_en": "Held — multiple warehouses",
      "label_th": "ระงับ — หลายคลังสินค้า",
      "intent": "warning"
    },
    {
      "code": "held_breaker",
      "label_en": "Held — circuit breaker",
      "label_th": "ระงับ — เบรกเกอร์วงจร",
      "intent": "warning"
    },
    {
      "code": "disabled",
      "label_en": "Disabled",
      "label_th": "ปิดใช้งาน",
      "intent": "neutral"
    }
  ],
  "listing_status": [
    {
      "code": "mapped",
      "label_en": "Mapped",
      "label_th": "ผูกข้อมูลแล้ว",
      "intent": "success"
    },
    {
      "code": "unmapped",
      "label_en": "Unmapped",
      "label_th": "ยังไม่ผูกข้อมูล",
      "intent": "warning"
    },
    {
      "code": "duplicate",
      "label_en": "Duplicate",
      "label_th": "ข้อมูลซ้ำ",
      "intent": "danger"
    },
    {
      "code": "deleted",
      "label_en": "Deleted",
      "label_th": "ถูกลบ",
      "intent": "neutral"
    }
  ],
  "marketplace_connection": [
    {
      "code": "active",
      "label_en": "Connected",
      "label_th": "เชื่อมต่อแล้ว",
      "intent": "success"
    },
    {
      "code": "not_connected",
      "label_en": "Not connected",
      "label_th": "ยังไม่เชื่อมต่อ",
      "intent": "neutral"
    },
    {
      "code": "disconnected",
      "label_en": "Disconnected",
      "label_th": "ยกเลิกการเชื่อมต่อแล้ว",
      "intent": "neutral",
      "_note": "An operator disconnected this shop, or a newer shop replaced it. Deliberate, not a failure — distinct from revoked/expired, which are incidents."
    },
    {
      "code": "expired",
      "label_en": "Expired",
      "label_th": "หมดอายุ",
      "intent": "warning"
    },
    {
      "code": "revoked",
      "label_en": "Revoked",
      "label_th": "ถูกเพิกถอน",
      "intent": "danger",
      "_note": "ConnectionStatus.status — backend openapi.yaml (marketplace module)."
    }
  ]
}
